import {
    useContractWrite,
    useWalletClient
} from "wagmi";
import { waitForTransaction } from "wagmi/actions";
import {
    _notEmpty
} from "../utils";
import {
    CONFIRMATIONS_COUNT,
    ERROR_RWA_CLAIM_POSITION,
    ERROR_RWA_CLAIM_POSITION_WRITE
} from "../utils/config";
import { useGasEstimate } from "./useGasEstimate";

export const useRWAClaimRewards = ({
    config,
    forwardingDepositContract,
    contractFunctionName,
    topUpAmount,
}) => {
    const { data: signer } = useWalletClient();
    const { chainId } = config;

    const enabled = _notEmpty(forwardingDepositContract?.address);

    const {
        estimatedGas,
        estimatesGasFormatted,
        estimatedGasUSD,
        isError,
    } = useGasEstimate({
        contract: forwardingDepositContract,
        functionName: contractFunctionName,
        args: [topUpAmount],
        account: signer?.account,
        topUpAmount,
    });

    const contractWrite = useContractWrite({
        chainId,
        abi: forwardingDepositContract?.abi,
        address: forwardingDepositContract?.address,
        signerOrProvider: signer,
        functionName: contractFunctionName,
        enabled,
        onError: (error) => console.error(ERROR_RWA_CLAIM_POSITION_WRITE, error),
    });

    const executeTransaction = async ({
        amount,
        onConfirmation,
        onAccept, // Added this callback
        onComplete,
        onError,
    }) => {
        try {
            onConfirmation?.();

            const transaction = await contractWrite.writeAsync(
                contractFunctionName.includes("deposit") && { args: [amount] }
            );
            const { hash } = transaction;

            // Notify about the transaction hash
            onAccept?.(hash);

            const result = await waitForTransaction({
                hash,
                confirmations: CONFIRMATIONS_COUNT,
            });

            onComplete?.(result);
            return true;
        } catch (error) {
            console.error(ERROR_RWA_CLAIM_POSITION, error);
            onError?.(error);
            return false;
        }
    };

    const performAction = (params) =>
        executeTransaction({
            ...params,
            contract: contractWrite,
        });

    return {
        performAction,
        estimatedGas,
        estimatesGasFormatted,
        estimatedGasUSD,
        estimateHasError: isError,
        isLoading: contractWrite.isLoading,
    };
};
